// import React, { useState, useEffect } from "react";
// import "../SubscriptionBlurPage/SubscriptionBlurPage.css";
// import { useNavigate } from "react-router-dom";
// import { getUserById, matchedUsers } from "../api/api";
// // import Header from "../../components/Header/Header";
// import blurImage from "../../assets/images/home_banner.jpg";

// const SubscriptionBlurPage = () => {
//   const navigate = useNavigate();
//   const [allUserData, setAllUserData] = useState([]);
//   const [currUserAllData, setCurrUserAllData] = useState("");
//   const [isLoading, setIsLoading] = useState(true);

//   const fetchUserData = async () => {
//     try {
//       const userData = JSON.parse(localStorage.getItem("currentUser"));
//       const _id = userData?.id || userData?._id;
//       if (_id) {
//         const currentUser = await getUserById({ user_id: _id });
//         setCurrUserAllData(currentUser);
//       }
//     } catch (error) {
//       console.error("Error fetching user data:", error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const getUserData = async () => {
//     try {
//       const userData = JSON.parse(localStorage.getItem("currentUser"));
//       const _id = userData?.id || userData?._id;
//       const currentUser = await matchedUsers({ user_id: _id });
//       console.log("currentUser55555555", JSON.stringify(currentUser));
//       setAllUserData(currentUser);
//     } catch (error) {
//       console.error("Error fetching matched users:", error);
//     }
//   };

//   const handleLogout = () => {
//     if (window.confirm("Do you really want to log out?")) {
//       localStorage.removeItem("currentUser");
//       navigate("/login");
//     }
//   };

//   useEffect(() => {
//     fetchUserData();
//     getUserData();
//   }, []);

//   const viewMemberDetail = (id) => {
//     navigate(`/member-profile/${id}`);
//   };

//   return (
//     <div className="blursubscription-container">
//       {/* <Header /> */}
//       {isLoading ? (
//         <div className="blurloader"></div>
//       ) : (
//         <>
//           <div className="blurbanner-container">
//             <img src={blurImage} alt="Banner" className="blurbanner-image" />
//           </div>

//           {Array.isArray(allUserData?.matched_users) &&
//           allUserData?.matched_users.length > 0 ? (
//             <div className="blurmatched-container">
//               <h3>People who match your profile</h3>
//               <div className="bluruser-scroll">
//                 {allUserData.matched_users.map((user, index) => (
//                   <div key={user?.id || index} className="bluruser-card">
//                     <div
//                       className="bluruser-image"
//                       onClick={() => viewMemberDetail(user?.id)}
//                       style={{
//                         backgroundImage: `url(${
//                           user?.more_images?.length
//                             ? `/uploads/users/${user?.more_images[0]}`
//                             : "/assets/default-user.jpg"
//                         })`,
//                       }}
//                     >
//                       <div className="bluruser-name">{user?.name}</div>
//                     </div>
//                     <div className="bluruser-age">{user?.age} Years</div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           ) : (
//             <div className="blurno-match-message">
//               <p className="Blurmessage">
//                 {allUserData?.message || "No matches found."}
//               </p>
//             </div>
//           )}
//         </>
//       )}

//       {!isLoading &&
//         currUserAllData?.data?.activeSubscriptionStatus === "0" && (
//           <div className="blurblur-overlay">
//             <div className="blursubscription-box">
//               <h2>Unlock Full Access</h2>
//               <p>
//                 To view user profiles and explore all premium features, please
//                 select a subscription plan that suits you.
//               </p>
//               <button
//                 className="blurbtn teal"
//                 onClick={() =>
//                   navigate("/SubscriptionPlans", {
//                     state: { counsellingEnabled: "0" },
//                   })
//                 }
//               >
//                 OK
//               </button>
//               <button className="blurbtn coral" onClick={handleLogout}>
//                 Logout
//               </button>
//             </div>
//           </div>
//         )}
//     </div>
//   );
// };

// export default SubscriptionBlurPage;

import React, { useState, useEffect } from "react";
import "../SubscriptionBlurPage/SubscriptionBlurPage.css";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getActiveSubscription,
  getUserById,
  matchedUsers,
  getPendingRequests,
} from "../api/api";
import blurImage from "../../assets/images/home_banner.jpg";
import Swal from "sweetalert2";

const SubscriptionBlurPage = () => {
  const navigate = useNavigate();
  const [allUserData, setAllUserData] = useState([]);
  const [currUserAllData, setCurrUserAllData] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const { past_due } = location.state || {};
  console.log("past_due4444444", past_due);
  const fetchUserData = async () => {
    try {
      const userData = JSON.parse(localStorage.getItem("currentUser"));
      const _id = userData?.id || userData?._id;
      if (_id) {
        const currentUser = await getUserById({ user_id: _id });
        console.log("currentUser123456", currentUser);
        setCurrUserAllData(currentUser);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const getUserData = async () => {
    try {
      const userData = JSON.parse(localStorage.getItem("currentUser"));
      const _id = userData?.id || userData?._id;
      const currentUser = await matchedUsers({ user_id: _id });
      console.log("currentUser55555555", JSON.stringify(currentUser));
      setAllUserData(currentUser);
    } catch (error) {
      console.error("Error fetching matched users:", error);
    }
  };

  // const handleLogout = () => {
  //   if (window.confirm("Do you really want to log out?")) {
  //     localStorage.removeItem("currentUser");
  //     navigate("/login");
  //   }
  // };
  const handleLogout = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to log out?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#e04a48",
      cancelButtonColor: "#808080",
      confirmButtonText: "Yes, Logout",
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.removeItem("currentUser");
        navigate("/login");
        // Swal.fire("Logged Out!", "You have been logged out.", "success");
      }
    });
  };

  useEffect(() => {
    fetchUserData();
    getUserData();
  }, []);

  const viewMemberDetail = (id) => {
    navigate(`/member-profile/${id}`);
  };
  const handlePlanPayment = async (plan) => {
    // const userData = await AsyncStorage.getItem("currentUser");
    // const parsedUserData = JSON.parse(userData);
    // const _id = parsedUserData?.id || parsedUserData?._id;
    const userData = JSON.parse(localStorage.getItem("currentUser"));
    const _id = userData?.id || userData?._id;
    console.log(
      "currUserAllData?.data?.stripe_subscription_id--------------------------",
      currUserAllData?.data?.stripe_subscription_id
    );
    const url = `https://backend.connecttovow.com/subscription/retry/${currUserAllData?.data?.stripe_subscription_id}`;
    navigate("/ConnectionPaymentWebView", { state: { paymentUrl: url } });
  };

  return (
    <div className="blursubscription-container">
      {isLoading ? (
        <div className="blurloader"></div>
      ) : (
        <>
          <div className="blurbanner-container">
            <img src={blurImage} alt="Banner" className="blurbanner-image" />
          </div>

          {Array.isArray(allUserData?.matched_users) &&
          allUserData?.matched_users.length > 0 ? (
            <div className="blurmatched-container">
              <h3>People who match your profile</h3>
              <div className="bluruser-scroll">
                {allUserData.matched_users.map((user, index) => (
                  <div key={user?.id || index} className="bluruser-card">
                    <div
                      className="bluruser-image"
                      onClick={() => viewMemberDetail(user?.id)}
                      style={{
                        backgroundImage: `url(${
                          user?.more_images?.length
                            ? `/uploads/users/${user?.more_images[0]}`
                            : "/assets/default-user.jpg"
                        })`,
                      }}
                    >
                      <div className="bluruser-name">{user?.name}</div>
                    </div>
                    <div className="bluruser-age">{user?.age} Years</div>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div className="blurno-match-message">
              <p className="Blurmessage">
                {allUserData?.message || "No matches found."}
              </p>
            </div>
          )}
        </>
      )}

      {!isLoading &&
        // currUserAllData?.data?.activeSubscriptionStatus === "0"
        currUserAllData?.data?.subscription?.object !== "subscription" && (
          <div className="blurblur-overlay">
            <div className="blursubscription-box">
              <h2>
                {past_due === "past_due" ? "Payment Due" : "Unlock Full Access"}
              </h2>
              <p>
                {/* To view user profiles and explore all premium features, please
                select a subscription plan that suits you. */}
                {past_due === "past_due"
                  ? 'To renew subscription, you need to authenticate security checks in order to complete the payment. Press "Authenticate" below and complete the next process.'
                  : "To view user profiles and explore all premium features, please select a subscription plan that suits you. Get started to enjoy the full experience on our platform."}
              </p>
              {past_due === "past_due" ? (
                <button
                  className="blurbtn teal"
                  onClick={() => handlePlanPayment()}
                >
                  Authenticate
                </button>
              ) : (
                <button
                  className="blurbtn teal"
                  onClick={() =>
                    navigate("/SubscriptionPlans", {
                      state: { counsellingEnabled: "0" },
                    })
                  }
                >
                  OK
                </button>
              )}
              <button className="blurbtn coral" onClick={handleLogout}>
                Logout
              </button>
            </div>
          </div>
        )}
    </div>
  );
};

export default SubscriptionBlurPage;
